var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ni-show',{staticClass:"my-2",attrs:{"no-placeholder":true,"header":_vm.url,"cols":"12","sm":"3"}},[_c('v-chip',{staticClass:"text-uppercase",attrs:{"color":_vm.color,"label":"","small":""}},[_vm._v(" "+_vm._s(_vm.status)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }